// let vendor_js_footer = [
//     paths.src.js + 'vendor/bootstrap.bundle.min.js',
//     paths.src.js + 'vendor/fancybox.umd.js'
// ];

// From inc/ directory
import "./inc/map_search.js";
import "./inc/market_modal.js";
import "./inc/read_more.js";
import "./inc/retail_user.js";
import "./inc/modal_form_close.js";
import "./inc/schedule_modal.js";
import "./inc/form_modal.js";
import "./inc/cutaway.js";
import "./inc/fade_up.js";
import "./inc/parallax.js";
import "./inc/resource_cards.js";
import "./inc/autocomplete_bfcache_reset.js";
import "./inc/stats_section.js";
import "./inc/video_modal.js";
import "./inc/hero_video.js";
import "./inc/promo_countdown.js";
import "./inc/isp_zoom_scale.js";
import "./inc/a11y.js";

// Formerly in vendor.footer.js
import Swiper, {
    A11y,
    Autoplay,
    Controller,
    EffectCards,
    EffectCoverflow,
    EffectCreative,
    EffectCube,
    EffectFade,
    EffectFlip,
    FreeMode,
    Grid,
    HashNavigation,
    History,
    Keyboard,
    Lazy,
    Manipulation,
    Mousewheel,
    Navigation,
    Pagination,
    Parallax,
    Scrollbar,
    Thumbs,
    Virtual,
    Zoom,
} from 'swiper';
import { Fancybox } from "@fancyapps/ui";
import * as bootstrap from "bootstrap";

// oilib.js needs bootstrap to be available on the window object. It uses bootstrap popovers (maybe others, too).
window.bootstrap = bootstrap;
window.Swiper = Swiper;
Swiper.use([
    A11y,
    Autoplay,
    Controller,
    EffectCards,
    EffectCoverflow,
    EffectCreative,
    EffectCube,
    EffectFade,
    EffectFlip,
    FreeMode,
    Grid,
    HashNavigation,
    History,
    Keyboard,
    Lazy,
    Manipulation,
    Mousewheel,
    Navigation,
    Pagination,
    Parallax,
    Scrollbar,
    Thumbs,
    Virtual,
    Zoom,
]);

// WCAG: Swiper's Keyboard module ships disabled by default, and most carousels across
// the theme are inline `new Swiper(...)` calls in templates rather than here -- wrapping
// the global constructor turns keyboard nav + a11y announcements on everywhere at once,
// instead of editing every template's inline config individually. A template can still
// override either key explicitly since object properties win over these defaults.
// Note: this wrapper only reaches code that calls `window.Swiper` (every inline template
// instantiation does) -- the one `new Swiper(...)` call below in this same module uses
// the imported binding directly, so it needs the same config set explicitly instead.
const OriginalSwiper = window.Swiper;
const SWIPER_A11Y_DEFAULTS = {
    a11y: true,
    keyboard: { enabled: true, onlyInViewport: true },
};

window.Swiper = function (container, options = {}) {
    return new OriginalSwiper(container, deepMergeSwiperDefaults(SWIPER_A11Y_DEFAULTS, options));
};
Object.setPrototypeOf(window.Swiper, OriginalSwiper);
Object.assign(window.Swiper, OriginalSwiper);

function deepMergeSwiperDefaults(defaults, overrides) {
    const merged = { ...defaults };
    for (const key in overrides) {
        if (typeof overrides[key] === 'object' && overrides[key] !== null && !Array.isArray(overrides[key])) {
            merged[key] = typeof defaults[key] === 'object'
                ? deepMergeSwiperDefaults(defaults[key], overrides[key])
                : { ...overrides[key] };
        } else {
            merged[key] = overrides[key];
        }
    }
    return merged;
}

// =============================================================================
// Sticky nav "stuck" detection
/*
const stickyElm = document.querySelector('.main-navbar')

if (document.body.classList.contains('nav-overlay')) {
    // Overlay nav: toggle stuck based on scroll position
    const toggleOverlayStuck = () => stickyElm.classList.toggle('stuck', window.scrollY > 0);
    toggleOverlayStuck();
    window.addEventListener('scroll', toggleOverlayStuck, { passive: true });
} else {
    // Standard sticky nav: use IntersectionObserver
    const observer = new IntersectionObserver(
      ([e]) => e.target.classList.toggle('stuck', e.intersectionRatio < 1),
      {threshold: [1]}
    );
    observer.observe(stickyElm);
}*/

// =============================================================================
// Trigger Tabs By Hash

var triggerTabList = [].slice.call(document.querySelectorAll(".tab-btn"));

triggerTabList.forEach(function (triggerEl) {
  var tabTrigger = new bootstrap.Tab(triggerEl);
  var hash = '#' + triggerEl.href.split("#")[1];
  var tabBtn = document.querySelector( hash + "-tab");

  triggerEl.addEventListener("click", function (event) {
    event.preventDefault();
    tabBtn.click();
  })
})

// =============================================================================
// == Wrap Last Word In Span =============

function targetLastWord(element)
{
    var pieces = element.innerHTML.split(" ");
    var last = pieces.pop();
    var first = pieces.join(" ");
    element.innerHTML = first + '<span class="last-word"> ' + last + '</span>';
}

var lastWords =  document.querySelectorAll(".last-word-bold");
lastWords.forEach(x => targetLastWord(x));


// =============================================================================
// == Split String =============

function splitStringByBreak(element) {

    // Split the string into words
    var pieces = element.innerHTML.split(/<br\s*\/?>/, 2);
    var isAlreadySplit = element.getElementsByTagName('span');

    // Initialize arrays for the first and second halves
    var isTwoParts = pieces[1];
    var firstHalf = [];
    var secondHalf = [];
    
    if (isAlreadySplit.length == 0) {
        if(isTwoParts){
            var firstHalf = [pieces[0]];
            var secondHalf = [pieces[1]];
    
            // Join the halves back into strings
            var first = firstHalf.join(' ');
            var last = secondHalf.join(' ');
    
            element.innerHTML = '<span class="first-part"> ' + first + '</span><span class="second-part"> ' + last + '</span>';
        }
        else {
            var firstHalf = [pieces[0]];
            var first = firstHalf.join(' ');
    
            element.innerHTML = '<span class="second-part"> ' + first + '</span>';
        }
    }
}

var splitStrings = document.querySelectorAll(".split-string");
splitStrings.forEach(x => splitStringByBreak(x));

// =============================================================================
// == Focus on Search Open =============

const searchModal = document.getElementById('search-modal')
const searchInput = document.getElementById('modal-search')

searchModal.addEventListener('shown.bs.modal', () => {
    searchInput.focus()
})

// =============================================================================
// == Actual StickyNav Heights =============

    function updatePosition() {
        const mainNav = document.getElementById('site-nav');
        const subNav = document.getElementById('subnav');
        const filters = document.getElementById('filters');

        let stickyWNav = document.querySelectorAll('.sticky-w-nav');
        let stickyWSubnav = document.querySelectorAll('.sticky-w-subnav');
        let stickyWFilters = document.querySelectorAll('.sticky-w-filters');

        // Set the top position of each target element based on the height of the reference element
        stickyWNav.forEach(function(stickyItem) {
            if(mainNav){
                let mainNavHeight = mainNav.clientHeight;
                stickyItem.style.top = mainNavHeight + 'px';
            }
        });
        stickyWSubnav.forEach(function(stickyItem) {
            if(mainNav && subNav){
                let mainNavHeight = mainNav.clientHeight;
                let subNavHeight = subNav.clientHeight;
                stickyItem.style.top = mainNavHeight + subNavHeight + 'px';
            } else if(subNav) {
                let subNavHeight = subNav.clientHeight;
                stickyItem.style.top = mainNavHeight + subNavHeight + 'px';
            }
        });
        stickyWFilters.forEach(function(stickyItem) {
            // #site-nav is no longer sticky, so its height must not count
            // toward this offset — only sticky elements above this one
            // (subnav, filters) push it down.
            if(subNav && filters){
                let subNavHeight = subNav.clientHeight;
                let filtersHeight = filters.clientHeight;
                stickyItem.style.top = subNavHeight + filtersHeight + 'px';
            } else if(filters){
                let filtersHeight = filters.clientHeight;
                stickyItem.style.top = filtersHeight + 'px';
            }
        });

    }

    window.addEventListener('load', updatePosition);
    window.addEventListener('resize', updatePosition);

// =============================================================================

/*
 * FANCYBOX
 *
 * The new Fancybox v4 (non-jQuery) triggers a "done" event for up to three images when
 * the carousel is first initilaized. To avoid triggering 3 image view events on every
 * Fancybox initCarousel action, an imageview event is triggered on the initCarousel
 * event, but "done" events are then ignored for 1 second. After 1 second, image view
 * events will be triggered as typical.
 */

// Tracks fancybox image views.
let fancyboxEventBlock = false

// Abstracted event action handler
const doFancyboxOiEvent = (fancybox) => {
    let oi_event_name = false
    // Identify the proper event name. Use the first occurence from the possibilities
    // below.
    // 1. If a trigger element is available, use the value of data-oi-event-name when
    //    present. This is the most common scenario.
    // 2. If the Fancybox options object has oiEventName attribute, use the value. Event
    //    names are define this way when Fancybox assets are populated by a javascript
    //    array, and not DOM elements are available to place the data attribute.
    if (fancybox.options.$trigger
        && fancybox.options.$trigger.dataset
        && fancybox.options.$trigger.dataset.oiEventName) {
            oi_event_name = fancybox.options.$trigger.dataset.oiEventName
    }
    if (oi_event_name) {
        if ("undefined" != typeof window.dataLayer) {
            window.dataLayer.push({ event: oi_event_name });
        }
        if ("undefined" != typeof window.hfaDataLayer) {
            window.hfaDataLayer.push({ event: oi_event_name });
        }
    }
}

// Define Fancybox config
window.FANCYBOX_CONFIG = {
    on: {
        initCarousel: (fancybox) => {
            if(!fancyboxEventBlock) {
                // Block additional Fancybox events
                fancyboxEventBlock = true

                // Do Fancybox event
                doFancyboxOiEvent(fancybox)

                // Undo the event block after 1 second.
                setTimeout(() => {
                    fancyboxEventBlock = false
                }, 1000)
            }
        },
        done: (fancybox, slide) => {
            if(!fancyboxEventBlock) {
                // Do Fancybox event
                doFancyboxOiEvent(fancybox)
            }
        },
        destroy: () => {
            // Reset the block on Fancybox close.
            fancyboxEventBlock = false
        },
    },
}

// Bind actions to Fancybox events
Fancybox.bind("[data-fancybox]", FANCYBOX_CONFIG)

/* END FANCYBOX */

// =============================================================================
// == Collection Card Swipers =============

document.querySelectorAll('.collection-card-swiper').forEach(function (swiperEl) {
    new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        a11y: true,
        keyboard: { enabled: true, onlyInViewport: true },
        navigation: {
            nextEl: swiperEl.querySelector('.swiper-button-next'),
            prevEl: swiperEl.querySelector('.swiper-button-prev'),
        },
    });
});

// This fires the oi.utils function that will wrap all iframes contained in WYSIWYG
// editors with appropriate oi-aspect classes.

window.addEventListener('load', function () {
  oi.utils.wrap_oi_aspect();
}, false);

// =============================================================================
// == Map/List Bounds Sync: Close Grid Gaps =============
// oilib's card_marker_display_sync (see common_map.html) hides a card outside the
// map's current bounds by setting display:none directly on the card -- but the card
// sits one or more levels inside the actual row-cols-* grid cell (specs wraps it in
// one <div class="col"> in specs_result_list.html; locations wraps it in a <div
// class="col"> in locations_result_list.html AND location_card.html's own root
// carries class="col" too, so it's nested two deep there), so that empty grid cell
// keeps its slot in the row instead of collapsing, leaving a gap where the card used
// to be. Hide the actual grid cell instead of guessing how many .col levels deep the
// card is -- walk up from the card to whichever ancestor is a direct child of the
// .row, since that's the element row-cols-* is actually sizing -- driven off the
// same oimap_marker_visibility_changed event oilib already dispatches on every
// bounds change.
window.addEventListener('oimap_marker_visibility_changed', function (event) {
    var visibleIds = new Set(event.detail.map(function (listing) { return String(listing.listing_id); }));
    document.querySelectorAll('#oi-filter-results [data-listing-id]').forEach(function (card) {
        var row = card.closest('.row');
        if (!row) return;
        var cell = card;
        while (cell.parentElement && cell.parentElement !== row) {
            cell = cell.parentElement;
        }
        if (cell.parentElement === row) {
            cell.classList.toggle('d-none', !visibleIds.has(card.dataset.listingId));
        }
    });
});

// =============================================================================
// == ISP zoom control keyboard support =============
// The @oijs/oilib panzoom widget (isp.js) only wires up a click listener on these
// controls, no keyboard handling -- forward Enter/Space to a real click so the
// role="button" markup in location_isp.html is actually operable, not just labeled.
document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var btn = e.target.closest && e.target.closest('.oi-zoom-in, .oi-zoom-out, .oi-zoom-reset');
    if (btn) {
        e.preventDefault();
        btn.click();
    }
});

// =============================================================================
// == Equal Height Groups =============
// Usage: add data-eq-group=".selector" to a parent container.
// All matching children within that parent are set to the same height.
// Multiple parents on the same page equalize independently.
//
// data-eq-group also accepts a comma-separated list of selectors
// (e.g. ".card-icon, .eyebrow, .card-title") to align several independent
// rows of content across a set of cards -- each selector in the list is
// equalized on its own (its own max height), not lumped in with the others,
// so e.g. every card's icon lines up with every other card's icon, and
// separately every card's heading lines up with every other heading, even
// though icons and headings are naturally different heights from each other.
function equalizeGroups() {
    document.querySelectorAll('[data-eq-group]').forEach(function (parent) {
        parent.dataset.eqGroup.split(',').forEach(function (selector) {
            selector = selector.trim();
            if (!selector) return;
            var items = parent.querySelectorAll(selector);
            var maxH = 0;
            items.forEach(function (el) { el.style.height = ''; });
            items.forEach(function (el) { maxH = Math.max(maxH, el.offsetHeight); });
            if (maxH > 0) items.forEach(function (el) { el.style.height = maxH + 'px'; });
        });
    });
}

document.addEventListener('DOMContentLoaded', equalizeGroups);
var _eqResizeTimer;
window.addEventListener('resize', function () {
    clearTimeout(_eqResizeTimer);
    _eqResizeTimer = setTimeout(equalizeGroups, 150);
});
